export default "/img/BS.c6745fe83b1206ec273be55fb271b8bd.png";